export default "__VITE_ASSET__DppOD_Bw__"